import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  max-inline-size: 60px;

  text-align: center;

  cursor: pointer;
`;

export const ItemName = styled.div`
  color: #4585ff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
`;

export const LogoWrapper = styled.div`
  inline-size: 60px;
  block-size: 60px;
  margin-inline-end: 0;

  border: 2px solid #4585ff;
  border-radius: 50%;

  overflow: hidden;
`;

export const Logo = styled.img`
  inline-size: 100%;
  block-size: 100%;

  filter: grayscale(100%);

  object-fit: contain;
`;
